import React, { useState } from 'react';
import AlertModal, {
  AlertModalType,
} from '../../shared/components/custom/AlertModal';
import { partial } from '../../util/translation/translation';

/** What sendWithOverride resolves to when the admin chose not to go over */
export const OVER_LIMIT_DECLINED = 'overLimitDeclined';

const isLimitError = (err) =>
  err?.data?.message === 'participant.EventLimitReached';

/**
 * Admins may go over an event's places, which the app never can: a request
 * the events service refuses with participant.EventLimitReached is sent
 * again with ignoreLimits once the admin says yes.
 *
 * sendWithOverride(send): send(ignoreLimits) makes the request. Resolves to
 * its result, or OVER_LIMIT_DECLINED; other errors are thrown as before.
 * confirmModal: render it on the page using it.
 */
const useOverLimitConfirm = () => {
  const p = partial('EventPayments');
  const [request, setRequest] = useState(null);

  const ask = (err) =>
    new Promise((resolve) =>
      setRequest({ freePlaces: err?.data?.freePlaces, resolve })
    );
  const answer = (yes) => {
    request?.resolve(yes);
    setRequest(null);
  };

  const sendWithOverride = async (send) => {
    try {
      return await send(false);
    } catch (err) {
      if (!isLimitError(err)) throw err;
      if (!(await ask(err))) return OVER_LIMIT_DECLINED;
      return send(true);
    }
  };

  const freePlaces = request?.freePlaces;
  const confirmModal = (
    <AlertModal
      visible={!!request}
      modalType={AlertModalType.CONFIRMATION}
      message={
        freePlaces !== undefined && freePlaces !== null
          ? p('overLimitConfirm', { count: freePlaces })
          : p('overLimitConfirmFull')
      }
      modalAction={() => answer(true)}
      handleModal={() => answer(false)}
    />
  );

  return { sendWithOverride, confirmModal };
};

export default useOverLimitConfirm;
